<template>
  <div class="container">
    <table class="table table-borderless">
      <tbody class="body">
        <tr>
          <td class="col-6 head">Transfer Batch No.</td>
          <td class="col-6 head">Content Type</td>
        </tr>
        <tr>
          <td class="content">{{ contentStore.currentContent.name }}</td>
          <td class="content">{{ contentStore.currentContent.contentType }}</td>
        </tr>
        <tr>
          <td class="head">Date Received</td>
          <td class="head">Location</td>
        </tr>
        <tr>
          <td class="content">
            {{
              $filters.formatDateAndTime(
                contentStore.currentFileFormat.createdAt
              )
            }}
          </td>
          <td class="content">{{ contentStore.currentFileFormat.location }}</td>
        </tr>
        <tr>
          <td class="head">Status</td>
          <td class="head">Version</td>
        </tr>
        <tr>
          <td class="content">{{ contentStore.currentFileFormat.status }}</td>
          <td class="content">
            {{ contentStore.currentFileFormat.versionNumber }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { useContentStore } from "@/stores/content_review/content";
import { useAsyncState } from "@vueuse/core";
import { watch } from "vue";

const contentStore = useContentStore();

watch(
  () => props.transferId,
  () => execute()
);

const props = defineProps({
  transferId: { type: String, required: true },
});

const { execute, error } = useAsyncState(() => {
  return contentStore.fetchFileFormatCategoryChanges(props.transferId);
}, null);
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  padding: 16px;
  min-width: 100%;
  overflow: auto;
}
</style>
